import React, { Fragment } from 'react';
import styles from './color-panel.less';
import i18n from '@i18next/i18n';
import ColorPickerContainer from '@src/js/common/ark-extensions/dc-components/color-picker/color-picker-container';
import { ColorPickerType } from '@src/js/common/ark-extensions/dc-components/color-picker/type';
import BACK_ICON from '@tencent/docs-design-resources/mobile/svg/navigation_back.svg';
import { ColorPanelType } from '@com-m/edit-panel-m/const';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { SolidFill } from '@src/slide/domain/ui-model/plugin/referModels/FillClass';
import { MenuType } from '@src/slide/domain/ui-model/constant/menu';
import {
    IMobileEditorAppServices,
} from '@src/slide/application/entry/toc/editor/mobile/mobile-editor-app-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import _has from 'lodash/has';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType, TDWVer5Type, TDWVer6Type,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import {
    IColorPickerManager,
} from '@src/slide/application/service/color-picker-manager/color-picker-manager.interface';
import { ITDColor, TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';

interface IColorPanelProps {
    colorPanelType: ColorPanelType;
    closeColorPanel(): void;
}

export default class ColorPanel extends React.Component<IColorPanelProps, any> {
    render() {
        let title;
        let actionType;
        switch (this.props.colorPanelType) {
            case ColorPanelType.FILL:
                title = i18n.t('填充颜色');
                actionType = TDWVer5Type.COLOR_PICKER_FILL;
                break;
            case ColorPanelType.BORDER:
                title = i18n.t('边框颜色');
                actionType = TDWVer5Type.COLOR_PICKER_BORDER;
                break;
            default:
                title = i18n.t('文字颜色');
                actionType = TDWVer5Type.COLOR_PICKER_FORE_FONT;
        }
        return <Fragment>
            <div className={styles['mobile-color-panel-title']}>
                <img
                    onClick={this.props.closeColorPanel}
                    className={styles['mobile-color-panel-title-back']}
                    src={BACK_ICON}
                />
                <div className={styles['mobile-color-panel-title-text']}>
                    {title}
                </div>
            </div>
            <div className={styles['mobile-color-panel-content']}>
                <ColorPickerContainer
                    selectedTdColor={this.getModelColor(this.getModeAndValue())}
                    onColorChange={(tdColor, from) => {
                        this.onColorChange?.(tdColor);
                        this.getColorPickerManager()?.colorPickerTdwReport({
                            color: tdColor.srgb_color,
                            colorPickerFrom: TDWVer6Type.COLOR_PICKER_DRAWER,
                            colorGroupFrom: from,
                            actionType,
                        });
                    }}
                    colorPickerType={ColorPickerType.StandardMobile}
                />
            </div>
        </Fragment>;
    }

    private onColorChange = (tdColor: TDColor) => {
        const curModel = this.getAppServices().viewableServiceLayer.selectionService.selectedElements.getCurrentModel();
        if (this.props.colorPanelType === ColorPanelType.FILL) {
            curModel?.getBackgroundFill().updateCurrentFill({ solidFill: new SolidFill(tdColor) });
            return;
        }
        if (this.props.colorPanelType === ColorPanelType.BORDER) {
            curModel?.getBorder?.()?.updateCurrentBorder({ color: tdColor.srgb_color, tdColor });
            return;
        }
        this.getMenuManager()?.toolbarMenu()
            .callback(MenuType.TOOLBAR, ActionType.FORECOLOR, tdColor);
    };

    private getAppServices(): IMobileEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as
            IMobileEditorAppServices;
    }

    private getColorPickerManager(): IColorPickerManager | undefined {
        return this.getAppServices().editableServiceLayer?.colorPickerManager;
    }

    private getMenuManager(): IMenuManager | undefined {
        return this.getAppServices().editableServiceLayer?.menuManager;
    }

    private getModeAndValue = () => {
        let value;
        const curModel = this.getAppServices().viewableServiceLayer.selectionService.selectedElements.getCurrentModel();
        if (this.props.colorPanelType === ColorPanelType.FILL) {
            value = curModel?.getBackgroundFill()
                .getFillInfo()?.solidFill;
        } else if (this.props.colorPanelType === ColorPanelType.BORDER) {
            value = curModel?.getBorder?.()
                .getBorderInfo();
        } else {
            value = this.getForeColor();
        }
        return value;
    };

    // 获取文本颜色
    private getForeColor() {
        const values = this.getMenuManager()?.toolbarMenu().values;
        return {
            tdColor: values?.[ActionType.FONT_THEME_COLOR] || '',
        };
    }

    // 获取model颜色
    private getModelColor = value => value?.tdColor || value?.color;
}
